/* eslint-disable */
import React from 'react';
import { ChartTypeDefinition, ChartCategory } from '../../../helpers/chart-type.registry';
import { CategoryHeader } from './CategoryHeader';
import { ChartTypeGrid } from './ChartTypeGrid';
import './CategorySection.scss';

interface CategorySectionProps {
	category: ChartCategory;
	definitions: ChartTypeDefinition[];
	selectedType?: string;
	isSingleSeries: boolean;
	isExpanded: boolean;
	onToggle: () => void;
	onSelectType: (type: string) => void;
}

export const CategorySection: React.FC<CategorySectionProps> = ({
	category,
	definitions,
	selectedType,
	isSingleSeries,
	isExpanded,
	onToggle,
	onSelectType,
}) => {
	if (definitions.length === 0) {
		return null;
	}

	return (
		<div className="category-section">
			<CategoryHeader
				category={category}
				isExpanded={isExpanded}
				typeCount={definitions.length}
				onToggle={onToggle}
			/>
			{isExpanded && (
				<ChartTypeGrid
					definitions={definitions}
					selectedType={selectedType}
					isSingleSeries={isSingleSeries}
					onSelectType={onSelectType}
				/>
			)}
		</div>
	);
};
